import React, { useContext, useEffect, useState } from "react";

import { Form, Toast } from "antd-mobile";
import PsContext from "../../context";
import {
  jsonToQuery,
  lowerCase,
  momentDate,
  PsSelect,
  upperCase,
} from "../../utils";
import Header from "../header";

import axios from "axios";
import { Button, Card } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import {
  _CurrentSemesterStartAndEndDate,
  _GetDayValueByDate,
  currentSemesterStartAndEndDate,
  getDayValueByDate,
} from "../../models/academicYears";
import { ServiceUrl } from "../../utils/serviceUrl";
import SelectRecords from "../selectRecords";

const GeneralAtttendanceEntry = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  let params = useParams();
  const [loader, setLoader] = useState(false);
  const [showHours, setShowHours] = useState(false);

  const [selectedCourse, setSelectedCourse] = useState([]);
  const [subjects, setSubjects] = useState([]);

  const [markedData, setMarkedData] = useState([]);

  const [semDate, setSemDate] = useState([]);
  const [attendanceDate, setAttendanceDate] = useState(
    momentDate(new Date(), "YYYY-MM-DD"),
  );
  const [selectedHour, setSelectedHour] = useState("1");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [dayValue, setDayValue] = useState("");

  const [selectedHourList, setSelectedHourList] = useState([]);

  const [attendance_hour_per_day, setHourCount] = useState(null);

  const specialEntry = params?.special
    ? lowerCase(params.special) == "elective"
      ? "Elective"
      : "Special"
    : false;

  useEffect(() => {
    console.log(selectedCourse);
    if (selectedCourse.batch) {
      if (!selectedCourse.att_hour_per_day) {
        console.log(
          context.settingValue(
            "hour_for_attendance_per_day",
            context.user.college_uuid,
          ),
        );
        setHourCount(
          context.settingValue(
            "hour_for_attendance_per_day",
            context.user.college_uuid,
          ),
        );
        if (
          !context.settingValue(
            "hour_for_attendance_per_day",
            context.user.college_uuid,
          )
        ) {
          Toast.show({
            content: "Attendance hour not assigned for this course and batch.",
          });
        }
      } else {
        setHourCount(selectedCourse.att_hour_per_day);
      }

      _CurrentSemesterStartAndEndDate({
        batch: selectedCourse.batch,
        semester: selectedCourse.semester,
        college_uuid: context.user.college_uuid,
      }).then((res) => res.data && setSemDate(res.data));
      loadSubjects();
      loadMarkedDayDetails();
    }
  }, [JSON.stringify(selectedCourse)]);

  useEffect(() => {
    context.setLoader(true);
    _GetDayValueByDate({
      date: attendanceDate,
      college_uuid: context.user.college_uuid,
    }).then((res) => {
      if (res.data) setDayValue(res.data);
      context.setLoader(false);
    });
    loadMarkedDayDetails();
  }, [attendanceDate]);

  const loadMarkedDayDetails = () => {
    //DATE_MARKED_LIST
    if (!selectedCourse.course_uuid) return;
    context.setLoader(true);
    const form = new FormData();
    form.append("course_uuid", selectedCourse.course_uuid);
    form.append("college_uuid", context.user.college_uuid);
    form.append("batch", selectedCourse.batch);
    form.append("semester", selectedCourse.semester);
    form.append("section", selectedCourse.section);
    form.append("date", attendanceDate);
    axios.post(ServiceUrl.MOB.DATE_MARKED_LIST, form).then((res) => {
      if (res["data"].status == "1") {
        setMarkedData(res["data"].data);
      } else setMarkedData([]);
      context.setLoader(false);
    });
  };

  const getRightAction = () => {
    if (selectedCourse.course_uuid) {
      return (
        <li onClick={(e) => resetAll()}>
          <span>Cancel</span>
        </li>
      );
    } else return [];
  };

  const resetAll = () => {
    setSelectedCourse([]);
    setSelectedHour("1");
    setAttendanceDate("");
    setSelectedHourList([]);
    setHourCount(null);
  };

  const loadSubjects = () => {
    context.setLoader(true);
    const form = new FormData();
    form.append("course_uuid", selectedCourse.course_uuid || "0");
    form.append("college_uuid", context.user.college_uuid);
    form.append("batch", selectedCourse.batch);
    form.append("semester", selectedCourse.semester);
    form.append("elective", lowerCase(specialEntry) == "elective" ? "1" : "0");
    axios.post(ServiceUrl.MOB.LIST_COURSE_WISE_SUBJECTS, form).then((res) => {
      if (res["data"].status == "1") {
        setSubjects(res["data"].data);
      } else {
        Toast.show({
          content: res["data"].message || "Error",
        });
      }
      context.setLoader(false);
    });
  };

  const getSubjectField = (fieldName = false) => {
    let s = subjects.find((item) => item.subject_id == selectedSubject);

    return fieldName ? s?.[fieldName] : s;
  };
  const studentsViewClick = () => {
    let error = false;
    if (!attendanceDate) error = true;
    else if (!selectedHour && selectedHourList.length < 1) error = true;
    else if (!selectedSubject) error = true;

    if (error) {
      Toast.show({
        content: "Please Select all the fields",
      });
      return;
    }
    let s_s = getSubjectField();
    let x = {
      batch: selectedCourse.batch,
      course_uuid: selectedCourse.course_uuid || 0,
      college_uuid: context.user.college_uuid,
      coursetype: selectedCourse.course_type,
      semester: selectedCourse.semester,
      subject_code: s_s.subject_code || "",
      section:
        lowerCase(specialEntry) != "elective" ? selectedCourse.section : 0,
      subject: selectedSubject,
      attendance_date: attendanceDate,
      hour_value: selectedHour || Object.values(selectedHourList).toString(),
      day_value: dayValue,
      subject_name: getSubjectName(),
      college_year: context.user.college_year,
      teacher: context.user.uuid,
      entry_type: !specialEntry ? "general" : lowerCase(specialEntry),
      part: lowerCase(specialEntry),
      lastParam: "sample",
    };

    navigate("/staff/app/attendance-entry?" + jsonToQuery(x));
  };

  const getSubjectName = () => {
    let s = getSubjectField();
    return `${s.subject_name} ${s.short_name ? " - " + s.short_name : ""}`;
  };

  const hourExist = (h) => {
    // Dynamically compute the property name using bracket notation
    let s = markedData.find((item) => item[`hour_${h}_value`] == h);
    console.log(s);

    return s ? true : false;
  };

  const hourExistInList = (h) => {
    let s = selectedHourList.find((item) => item == h);
    return s ? true : false;
  };

  const multiHourCheck = (h) => {
    let m = [...selectedHourList];

    let s = m.find((item) => item == h);

    if (s) m = m.filter((item) => item != h);
    else m.push(h);
    setSelectedHourList(m);
    setSelectedHour("");
  };

  return (
    <>
      <Header
        hideLogoText={true}
        title={`${specialEntry || "General "} Attendance Entry`}
        rightActions={getRightAction()}
        backAction={true}
      />

      <div className="py-md-3">
        <div className="container-sm ">
          {!selectedCourse.batch && (
            <div data-aos="zoom-in">
              <Card>
                <Card.Header className="card-header-bg text-uppercase fw-bold">
                  Search
                </Card.Header>
                <Card.Body className="p-0">
                  <SelectRecords
                    withAttHour
                    onSuccess={(d) => setSelectedCourse(d)}
                    currentSem={true}
                    withOutSection={
                      lowerCase(specialEntry) == "elective" ? true : false
                    }
                    withOutCourse={
                      lowerCase(specialEntry) == "elective" ? true : false
                    }
                  />
                </Card.Body>
              </Card>
            </div>
          )}

          {selectedCourse.batch && (
            <>
              <Card>
                <Card.Header className="card-header-bg fw-bold text-uppercase">
                  Search
                </Card.Header>
                <Card.Body>
                  <label>Attendance Date</label>
                  <input
                    className="form-control form-control-sm fw-bold"
                    type="date"
                    size="sm"
                    max={momentDate(new Date(), "YYYY-MM-DD")}
                    min={semDate?.start_date}
                    value={attendanceDate}
                    onChange={(e) => {
                      setAttendanceDate(e.target.value);
                      setSelectedHourList([]);
                      setSelectedHour("");
                    }}
                  />

                  <Form.Item name="hour_value" label="Hour">
                    {lowerCase(specialEntry) != "special" && (
                      <select
                        className="form-select form-select-sm fw-bold"
                        onChange={(e) => setSelectedHour(e.target.value)}
                      >
                        <option value="">-Select-</option>
                        {Array.from(
                          { length: attendance_hour_per_day },
                          (v, i) =>
                            !hourExist(i + 1) && (
                              <option
                                value={i + 1}
                                selected={
                                  selectedHour == i + 1 ? "selected" : ""
                                }
                              >
                                Hour - {i + 1}
                              </option>
                            ),
                        )}
                      </select>
                    )}
                    {/*Array.from(
              { length: attendance_hour_per_day },
              (v, i) =>
                !hourExist(i + 1) && (
                  <lable className="w-100" for={i + 1}>
                    <input
                      type="radio"
                      checked={selectedHour == i + 1}
                      onClick={(e) => setSelectedHour(i + 1)}
                      value={i + 1}
                      name={"hour_value"}
                      className="me-2"
                    />
                    Hour - {i + 1}
                    <br />
                  </lable>
                )
            )*/}

                    {specialEntry &&
                      lowerCase(specialEntry) == "special" &&
                      Array.from(
                        { length: attendance_hour_per_day },
                        (v, i) =>
                          !hourExist(i + 1) && (
                            <lable className="w-100" for={i + 1}>
                              <input
                                type="checkbox"
                                checked={hourExistInList(i + 1)}
                                onChange={(e) => multiHourCheck(i + 1)}
                                value={i + 1}
                                name={"hour_value"}
                                className="me-2"
                              />
                              Hour - {i + 1}
                              <br />
                            </lable>
                          ),
                      )}
                  </Form.Item>
                  <Form.Item name="subject" label="Subject">
                    <PsSelect
                      dataSource={subjects}
                      size="small"
                      valueField="subject_id"
                      onChange={(d) => setSelectedSubject(d)}
                      value={selectedSubject}
                      lableField={(item) =>
                        `${upperCase(item.subject_code)} - ${
                          item.subject_name
                        } ${item.short_name ? " - " + item.short_name : ""}`
                      }
                    />
                    {/*<select
                      className="form-select form-select-sm fw-bold"
                      onChange={(e) => {
                        setSelectedSubject(e.target.value);
                      }}
                    >
                      <option value="">-</option>
                      {subjects.map((item) => (
                        <option
                          value={item.subject_id}
                          selected={
                            selectedSubject == item.subject_id ? "selected" : ""
                          }
                        >
                          {upperCase(item.subject_code)} - {item.subject_name}{" "}
                          {`${item.short_name ? " - " + item.short_name : ""}`}
                        </option>
                      ))}
                    </select>*/}
                  </Form.Item>
                  <Button
                    type="button"
                    size="lg"
                    variant="danger"
                    className="w-100 mt-3"
                    onClick={(e) => studentsViewClick()}
                  >
                    View Students
                  </Button>
                </Card.Body>
              </Card>
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default GeneralAtttendanceEntry;
